import api from "@/lib/api";

/** A turn of the conversation as held by the client and replayed to the stateless backend. */
export interface AssistantMessage {
	role: "user" | "assistant";
	content: string;
}

export interface AssistantSuggestion {
	id: string;
	label: string;
}

export interface AssistantChatResponse {
	reply: string;
	/** Names of the server-side tools used for this answer (debugging aid, not shown to admins). */
	toolsUsed: string[];
}

export const assistantAPI = {
	getStatus: async (): Promise<{ available: boolean }> => {
		const response = await api.get("/assistant/status");
		return response.data;
	},

	getSuggestions: async (lang: string): Promise<{ suggestions: AssistantSuggestion[] }> => {
		const response = await api.get("/assistant/suggestions", { params: { lang } });
		return response.data;
	},

	chat: async (payload: { messages: AssistantMessage[]; language: string }): Promise<AssistantChatResponse> => {
		// Model calls routinely exceed the shared 10s client default.
		const response = await api.post("/assistant/chat", payload, { timeout: 60000 });
		return response.data;
	},
};
